import { type FC } from 'react';
import { UiHStack, type UiHStackProps, UiImage, UiLink, UiStack, uiStyles, UiText } from '@/lib/ui';
import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';
import ProgressBar from '@/registration/component/Register/Layout/ProgressBar';
import GroupProgressBar from './GroupProgressBar';

export interface FooterProps extends UiHStackProps {
  isGroup?: boolean
  enableProgressBar?: boolean
}

const Footer: FC<FooterProps> = ({
  children,
  isGroup = false,
  enableProgressBar = true,
  ...props
}) => {
  return (
    <UiStack
      position={'fixed'}
      left={0}
      right={0}
      bottom={0}
      bgColor={'gray.100'}
      zIndex={999}
      borderTopWidth={'1px'}
      borderTopStyle={'solid'}
      borderTopColor={'gray.200'}
      // borderTopRadius={uiStyles.borderRadius}
      alignItems={'stretch'}
      spacing={0}
      enableDivider={false}
      {...props}
      // height={80}
      // boxShadow={'0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);'}
      // py={1}
      // shadow={'md'}
    >
      <UiStack>
        {
          enableProgressBar ? isGroup ? <GroupProgressBar /> : <ProgressBar /> : null
        }
      </UiStack>
      <UiHStack
        px={{base: 4, lg: 8}}
        py={{base: 4, lg: 6}}
        flexGrow={1}
      >
        {children}
      </UiHStack>
      {/*<BrandFooter/>*/}
    </UiStack>
  );
};

export default Footer;
